import { Route, Routes } from "react-router-dom";
import { MasterLayout } from "../../main/layout/MasterLayout";
import LandingPageWrapper from "../pages/Landing/LandingPageWrapper";
import WhyYatri from "../pages/WhyYatri/WhyYatri";
import AboutUs from "app/pages/AboutUs/AboutUs";
import PlatformWrapper from "../pages/Platform/PlatformWrapper";
import Resources from "../pages/Resources/Resources";
import Contactus from "../pages/Contactus/Contactus";
import Capacityplanning from "../pages/Platform/Capacityplanning";
import Operationalplanning from "../pages/Platform/Operationalplanning";
import Statergicplanning from "../pages/Platform/Statergicplanning";
import JeopradyManagement from "../pages/Platform/JeopradyManagement";
import RouteMapping from "../pages/Platform/RouteMapping";
import ScenarioModeling from "../pages/Platform/ScenarioModeling";
import Telecom from "../pages/Industries/Telecom";
import Healthcare from "../pages/Industries/Healthcare";
import EnergyUtilities from "../pages/Industries/EnergyUtilities";
import ServicesIndustry from "../pages/Industries/ServicesIndustry";
import ErrorsPage from "app/pages/module/errors/ErrorsPage";
import CookiesPolicy from "../pages/Policy/CookiePolicy";
import PrivacyPolicy from "../pages/Policy/PrivacyPolicy";

type Props = {};

const PrivateRoutes = (props: Props) => {
  return (
    <>
      <Routes>
        <Route element={<MasterLayout />}>
          <Route path="/" element={<LandingPageWrapper />} />
          <Route path="/why-yantr-ai" element={<WhyYatri />} />
          <Route path="/platform" element={<PlatformWrapper />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/cookies-policy" element={<CookiesPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/capacity-planning" element={<Capacityplanning />} />
          <Route
            path="/operational-planning"
            element={<Operationalplanning />}
          />
          <Route path="/strategic-planning" element={<Statergicplanning />} />
          <Route path="/jeopardy-management" element={<JeopradyManagement />} />
          <Route path="/route-mapping" element={<RouteMapping />} />
          <Route path="/scenario-modelling" element={<ScenarioModeling />} />
          <Route path="/telecom" element={<Telecom />} />
          <Route path="/healthcare" element={<Healthcare />} />
          <Route path="/energy-utilities" element={<EnergyUtilities />} />
          <Route path="/retail" element={<ServicesIndustry />} />
          <Route path="*" element={<ErrorsPage />} />
        </Route>
      </Routes>
    </>
  );
};

export default PrivateRoutes;
